// main.js
import React from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import cx from "classnames";
import UI    from "UI"
import PropTypes from 'prop-types';
import RCore from "RCore";
import moment from 'moment';
import Eventify from 'Eventify';
var i18 = {
    'en': {
        'venue': 'Stadium: {0}',
        'spectators': 'Attendance: {0}',
        'wdl.win' : "W",
        'wdl.draw': "D",
        'wdl.loss': "L",
        'points': 'points',
        'live': 'LIVE {0}\'',
        'ht': 'HT',
    },
    'da': {

    }
}
export default class EventHeader extends React.Component {

    constructor(props) {
        super(props);

        this.i18dict = i18;
        this.i18 = RCore.i18.bind(this);
    }

    static defaultProps = {
        type: 'default',
        useShortNames: false,
        simpleView: false
    }
    static contextTypes = {
        screenSizeObserver: PropTypes.object,
        info: PropTypes.object,
        teamLogoSettings: PropTypes.object,
        moment: PropTypes.func
    }

    componentDidMount() {
      // subscribe to future theme changes
      this.context.screenSizeObserver.subscribe(() => this.forceUpdate())
    }

    renderForm(form) {
        let event = this.props.event
        return (
            <div>
                <div className="wdp-wdl">
                    {form.results.map((ev) => {
                        ev.tournamentTemplateId = event.tournamentTemplateId;
                        ev.tournamentName       = event.tournamentName;
                        return <UI.Link
                                    action="event"
                                    withParams={ev}
                                    className={`wdp-wdl__item wdp-wdl__item__${ev.outcome}`}>{this.i18(`wdl.${ev.outcome}`)}</UI.Link>
                    })}
                </div>
                <div className="wdp-eh__info">#{form.rank}, {form.points} {this.i18(form.points > 1 ? 'points' : 'point')}</div>
            </div>
        )
    }

    renderGoals = (team, maxGoalsByTeam) => {
        let event = this.props.event && Eventify(this.props.event);
        let goalIds = [7, 8, 10, 12, 18, 28];
        let teamId = team == 'home' ? event.homeId : event.awayId
        let incidents = _.filter(event.incidents, inc => {
            let teamId = team == 'home' ? event.homeId : event.awayId;
            return (teamId == inc.teamId) && (goalIds.indexOf(inc.typeId) != -1);
        });


        if (incidents.length < maxGoalsByTeam) {
            // add fake lines
            for(var i = incidents.length; i < maxGoalsByTeam; i++) incidents.push('fake')
        }

        return _.map(incidents, (inc, i) => {
            if (inc == 'fake') return <div key={i}>{UI.nbsp}</div>
            let incContent = (
              <div>
                  <span className="incident-minute">{team == 'home' ? inc.min + "'" : ""}</span>
                  <span>{' ' +  (inc.participantName ? RCore.playerShortName(inc.participantName) : '-') + ' ' || ' '}</span>
                  <span className="incident-minute">{team == 'away' ? inc.min + "'" : ""}</span>
              </div>
            );
            var params = {teamId, teamName: inc.teamName, playerId: inc.participantId, playerName: inc.participantName}
            return (
                <div key={i}>
                    {inc.participantId && <UI.Link action="player" params={params}>{incContent}</UI.Link>}
                    {!inc.participantId && incContent}
                </div>
            )
        })
    };

    renderStub() {
        let {event = {}, additionalClasses = {}, useShortNames, form, simpleView} = this.props;
        var wrapperClasses = cx('wdp-eh', {
            'wdp-eh_simple': simpleView,
            ...additionalClasses
        });


        return <div className={wrapperClasses}>
        </div>
    }

    renderSimpleView(event) {


    }

    render() {
        let media = this.context.screenSizeObserver
        let {event = {}, additionalClasses = {}, useShortNames, form, simpleView} = this.props;

        if (_.isEmpty(event)) return this.renderStub();
        let {homeName, awayName, score} = event;

        let showTeamLogo = (this.context.teamLogoSettings && this.context.teamLogoSettings.display != 'none');

        event = Eventify(event);
        let evProperties = event.properties;

        if (media.isXS()  || media.isSM() || useShortNames === 'true' || useShortNames === true) {
            homeName = event.homeShortName || (event.homeName && event.homeName.substr(0, 3).toUpperCase());
            awayName = event.awayShortName || (event.awayName && event.awayName.substr(0, 3).toUpperCase());
        }

        let live        = event.isLive();
        let ht          = event.isHT();
        let coming      = event.isComing();
        let finished    = event.isFinished();
        let cancelled   = event.isCancelled();
        let postponed   = event.isPostponed();
        let notStarted  = event.statusType == 'notstarted';
        var mdate       = moment(event.startDate);


        let useLargeLogos = !media.isXS();
        // let useLargeLogos = true;

        let useSmallLogos = !useLargeLogos;


        var bottom = []
        bottom.push(evProperties && evProperties.venueName  && this.i18('venue', evProperties.venueName));
        bottom.push(evProperties && evProperties.spectators && this.i18('spectators', evProperties.spectators));

        var maxGoalsByTeam = score && Math.max(score.home, score.away) || 0;


        var wrapperClasses = cx('wdp-eh', {
            'wdp-eh_simple': simpleView,
            ...additionalClasses
        });


        if (simpleView) return (
            <div className={wrapperClasses}>
            {<div className="tac wdp-eh__info">
                {live} {ht}
            </div>}
                <div className="wdp-eh__board">
                    <div className="wdp-eh__team wdp-eh__team-home wdp-eh__team_winner">
                        <div className="wdp-eh__team-name">
                            {useSmallLogos && <UI.TeamLogo teamId={event.homeId} />}
                            <span>{homeName || UI.nbsp}</span>
                        </div>
                        {form && form.home && this.renderForm(form.home)}
                    </div>
                    {showTeamLogo && useLargeLogos && <div className="wdp-eh-logos-large">
                        <UI.TeamLogo teamId={event.homeId} />
                    </div>}


                    {live && ht && <span className="wdp-eh__live">{this.i18('ht')}</span>}
                    {live && !ht && <span className="wdp-eh__live">{this.i18('live', event.getMinutes())}</span>}

                    {!notStarted && <div className="wdp-eh__score">
                        <span>{score && score.home} - {score && score.away}</span>
                    </div>}
                    {notStarted && <div className="wdp-eh__score">
                        <div className=" wdp-eh__score__date">{this.context.moment(event.startDate).format('DD. MMM')}</div>
                        <div className=" wdp-eh__score__time">{this.context.moment(event.startDate).format('HH:mm')}</div>
                    </div>}
                    {showTeamLogo && useLargeLogos && <div className="wdp-eh-logos-large">
                        <UI.TeamLogo teamId={event.awayId} />
                    </div>}
                    <div className="wdp-eh__team wdp-eh__team-away">
                        <div className="wdp-eh__team-name">
                            <span>{awayName || UI.nbsp}</span>
                            {useSmallLogos && <UI.TeamLogo teamId={event.awayId} />}
                        </div>
                        {form && form.away && this.renderForm(form.away)}
                    </div>
                </div>
            </div>

        )

        return (
            <div className={wrapperClasses}>
                {!simpleView && <div className="tac wdp-eh__info">
                    <UI.Link action="tournament" withParams={event}>{event.tournamentName || UI.nbsp}</UI.Link>
                </div>}
                {!simpleView && <div className="tac wdp-eh__info">{event.startDate && mdate.format("D MMMM YYYY") || UI.nbsp}</div>}
                <div className="wdp-eh__board">
                    <div className="wdp-eh__team wdp-eh__team-home wdp-eh__team_winner">
                        <div className="wdp-eh__team-name">
                            {useSmallLogos && <UI.TeamLogo teamId={event.homeId} />}
                            <span>{homeName || UI.nbsp}</span>
                        </div>
                        {form && form.home && this.renderForm(form.home)}
                    </div>
                    {showTeamLogo && useLargeLogos && <div className="wdp-eh-logos-large">
                        <UI.TeamLogo teamId={event.homeId} />
                    </div>}


                    {live && ht && <span className="wdp-eh__live">{this.i18('ht')}</span>}
                    {live && ht && <span className="wdp-eh__live">{this.i18('live', event.getMinutes())}</span>}

                    {!notStarted && <div className="wdp-eh__score">

                        <span>{score && score.home} - {score && score.away}</span>
                    </div>}
                    {notStarted && <div className="wdp-eh__score">
                        <div className=" wdp-eh__score__date">{this.context.moment(event.startDate).format('DD. MMM')}</div>
                        <div className=" wdp-eh__score__time">{this.context.moment(event.startDate).format('HH:mm')}</div>
                    </div>}
                    {showTeamLogo && useLargeLogos && <div className="wdp-eh-logos-large">
                        <UI.TeamLogo teamId={event.awayId} />
                    </div>}
                    <div className="wdp-eh__team wdp-eh__team-away">
                        <div className="wdp-eh__team-name">
                            <span>{awayName || UI.nbsp}</span>
                            {useSmallLogos && <UI.TeamLogo teamId={event.awayId} />}
                        </div>
                        {form && form.away && this.renderForm(form.away)}
                    </div>
                </div>
                {event.incidents !== 'undefined' && !simpleView && (
                    <div className="wdp-eh__board_incidents">
                        <div className="wdp-eh__team wdp-eh__team-home wdp-eh__team-incidents">
                            {this.renderGoals('home', maxGoalsByTeam)}
                        </div>
                        {showTeamLogo && useLargeLogos && <div className="wdp-eh-logos-large"><div className="wdp-team-logo"/></div>}
                        <div className="wdp-eh__score"></div>
                        {showTeamLogo && useLargeLogos && <div className="wdp-eh-logos-large"><div className="wdp-team-logo"/></div>}
                        <div className="wdp-eh__team wdp-eh__team-incidents">
                            {this.renderGoals('away', maxGoalsByTeam)}
                        </div>
                    </div>
                )}
                {!simpleView && <div className="tac wdp-eh__info wdp-eh__venue-info">
                    {_.compact(bottom).join(" | ")}
                </div>}
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/EventHeader.js
 **/